import * as Yup from 'yup';
import DomPurify from 'dompurify';
import { TemplateFormHelperText } from '../../TemplateFormHelperText';
import { TemplateFormComponentMeta } from '../../../interfaces/template-form-component-meta';
import { TemplateFormAuthorizationButtonFieldMetaProps } from '../interfaces/template-form-auth-button-field-meta';
import { TemplateFormAuthorizationButtonField } from '../TemplateFormAuthorizationButtonField';
import { TemplateFormFieldValidationsFactory } from '../../../factories/templateFormFieldValidationFactory';

export const TemplateFormAuthorizationButtonFieldMeta: TemplateFormComponentMeta<
  TemplateFormAuthorizationButtonFieldMetaProps,
  {
    fortress_url?: string;
    auth_provider?: string;
  }
> = {
  component: TemplateFormAuthorizationButtonField,
  MetadataFactory: (field, disableEdit) => ({
    dataId: `template-form-${field.name}`,
    fieldName: field.name,
    disabled: disableEdit || !!field.disabled,
    label: DomPurify.sanitize(field.display_name ?? ''),
    helperText: TemplateFormHelperText({ helperText: field.helper_text, fieldName: field.name }),
    fortressUrl: field.component!.fortress_url ?? '',
    provider: field.component!.auth_provider ?? ''
  }),
  ValidationSchemaFactory: field => {
    const schema = Yup.number();

    return TemplateFormFieldValidationsFactory(field, schema);
  }
};
